import Select from "components/page/user/contract/edit/input/inputSelect";
import { BlockBase, HeadlineHeader } from "components/page/user/contract/edit/parts/blockBase";
import React from "react";

/** 種類 */
export default class Block1 extends BlockBase {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            headlineId: "030101",
        };
    }

    render() {
        const { hideBlockClass, params } = this.renderCommon();

        // 非表示判定の場合、null(react的な表示なし)を返す
        if (this.dohide(this.props.pageState.hidingHeadline)) { return null; }

        return (
            <div className={`dataList dataList__accordion ${hideBlockClass}`}>
                <div className="dataList-header">
                    <div className="dataList-header-title">種類</div>
                    <HeadlineHeader onClick={this.handleHide} hide={this.state.hide} />
                </div>
                <div className="dataList-body">
                    <table className="dataTable">
                        <tbody>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">種類</th>
                                <td className="dataTable-body dataTable-body__w355">
                                    <div className="selectBox selectBox__w250">
                                        <Select id="ID_FUD00344" name="FUD00344" value={this.props.pageState.FUD00344} items={this.getSelectbox(this.props.selectboxData.MEI00007)} {...params} />
                                    </div>
                                </td>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">第３７条書面<br />印刷</th>
                                <td className="dataTable-body dataTable-body__w355">
                                    <div className="selectBox selectBox__w250">
                                        <Select id="ID_FUD00351" name="FUD00351" value={this.props.pageState.FUD00351} items={this.getPrintSelectbox(this.props.selectboxData.MEI00009)} {...params} />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}